/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ContentEditor/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import No from './No/index'
import Plaintext from './Plaintext/index'
import React from 'react'
import Richtext from './Richtext/index'



/** @type {import('Simple/types.js').View} */
export default function ContentEditor({
  children,
  viewPath = "/App/Account/Content/Settings/Content/NoteTemplates/Template/NoteEditor/Content/ContentEditor"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let noteTemplatesTabNoteTemplateTagsValueData = fromData.useDataFormat({ viewPath,
context: 'note_templates_tab',
path: 'note_template.tags',
format: fromHelpers.tagsToEditor,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: noteTemplatesTabNoteTemplateTagsValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Richtext'}>
<Richtext
  viewPath={`${viewPath}/Richtext`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Plaintext'}>
<Plaintext
  viewPath={`${viewPath}/Plaintext`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}